"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandField_1 = __importDefault(require("../GraphandField"));
class GraphandFieldText extends GraphandField_1.default {
    getter(value, from) {
        if (!value) {
            return value;
        }
        if (this.multiple) {
            return typeof value === "string" ? [value] : value || [];
        }
        else {
            return Array.isArray(value) ? value[0] : value;
        }
    }
    setter(value) {
        if (!value) {
            return value;
        }
        if (this.multiple) {
            return value && !Array.isArray(value) ? [value] : value;
        }
        else {
            return value && Array.isArray(value) ? value[0] : value;
        }
    }
}
GraphandFieldText.__fieldType = "Text";
exports.default = GraphandFieldText;
